/**
 * English Translations
 */
export default {
  // Game status
  'game.yourTurn': 'Your turn',
  'game.waitingFor': 'Waiting for {playerName}',
  'game.connecting': 'Connecting...',
  'game.reconnecting': 'Reconnecting...',
  'game.winner': 'Winner: {playerName}',
  'game.wins': '{playerName} wins!',
  'game.draw': 'Draw!',
  'game.gameEnded': 'Game ended in a draw!',

  // Stats labels
  'stats.phase': 'Phase',
  'stats.central': 'Central',
  'stats.stack': 'Stack',
  'stats.hand': 'Hand',
  'stats.unknown': 'unknown',

  // Phase messages
  'phase.clickToStart': 'Click the central deck to start the game',
  'phase.waitingForStart': 'Waiting for {playerName} to start the game...',
  'phase.distributing': 'Distributing cards to player stacks...',
  'phase.dealing': 'Dealing cards to {playerName}...',
  'phase.redistributing': 'Redistributing cards from defeated {playerName}...',
  'phase.gameEnding': 'Game ending... Moving remaining cards...',

  // Action hints
  'hint.bonusExposed': 'General exposed! Click stack to draw a bonus card.',
  'hint.priorityTurn': 'Priority turn!',
  'hint.draw3Cards': 'Click stack to draw 3 cards.',
  'hint.draw2Cards': 'Click stack to draw 2 cards.',
  'hint.draw1Card': 'Click stack to draw 1 card.',
  'hint.unstash': 'Click stash to unstash.',
  'hint.selectCard': 'Click a hand card to select it.',
  'hint.cardSelected': 'Card selected. Click a highlighted target to play, or click the card again to deselect.',
  'hint.waitingForPlayer': 'Waiting for {playerName}...',

  // Buttons
  'button.endTurn': 'End Turn',
  'button.continue': 'Continue',
  'button.create': 'Create',
  'button.creating': 'Creating...',
  'button.join': 'Join',
  'button.joining': 'Joining...',
  'button.back': 'Back',
  'button.save': 'Save',
  'button.copyCode': 'Copy Code',
  'button.copyLink': 'Copy Link',
  'button.copied': 'Copied!',
  'button.changeName': 'Change Name',
  'button.ok': 'OK',

  // Lobby
  'lobby.title': 'Waterloo',
  'lobby.enterName': 'Enter your name to continue',
  'lobby.welcome': 'Welcome, {name}!',
  'lobby.createMatch': 'Create Match',
  'lobby.joinMatch': 'Join Match',
  'lobby.numPlayers': 'Number of Players',
  'lobby.players2': '2 Players',
  'lobby.players3': '3 Players',
  'lobby.players4': '4 Players',
  'lobby.matchCode': 'Match code',
  'lobby.yourName': 'Your name',
  'lobby.waitingRoom': 'Waiting Room',
  'lobby.matchCodeLabel': 'Match Code',
  'lobby.playersCount': 'Players ({joined}/{total})',
  'lobby.playerSlot': 'P{number}',
  'lobby.waiting': 'Waiting...',
  'lobby.you': '(You)',
  'lobby.autoStart': 'Game will start automatically when all players join',

  // Errors
  'error.enterMatchCode': 'Please enter a match code',
  'error.matchFull': 'Match is full',
  'error.createFailed': 'Failed to create match: {message}',
  'error.joinFailed': 'Failed to join match: {message}',
  'error.rematchFailed': 'Failed to join rematch: {message}',

  // Rematch modal
  'rematch.gameOver': 'Game Over',
  'rematch.joiningRematch': 'Joining Rematch...',
  'rematch.connecting': 'Connecting to new match',
  'rematch.askForRematch': 'Ask For Rematch',
  'rematch.notEnoughPlayers': 'Not enough players for rematch',
  'rematch.status': 'Rematch Status',
  'rematch.requested': 'requested',
  'rematch.ready': 'Ready',
  'rematch.pending': 'Waiting...',
  'rematch.declined': 'Declined',
  'rematch.startMatch': 'Start {count}-Player Match',
  'rematch.starting': 'Starting...',
  'rematch.cancelRematch': 'Cancel Rematch',
  'rematch.wantsRematch': '{playerName} wants a rematch!',
  'rematch.accept': 'Accept Rematch',
  'rematch.decline': 'Decline',
  'rematch.orStartDifferent': 'or start a different game',

  // Rules modal
  'rules.title': 'Game Rules',
  'rules.close': 'Close',
  'rules.buttonTitle': 'Show game rules',
  'rules.intro': 'Requires a Bavarian playing card set. For two to four players.\n\nAt the start of the game, all cards are dealt equally to all players. The cards may NOT be viewed, but are placed vertically in front of the player as a "deck". Each player then draws five cards from their deck. One card is placed vertically face-up next to the deck as the "General", and two more are placed horizontally face-up in front of the General as "Defenders". The remaining cards are not shown but are played as hand cards in the first round. The goal of the game is to be the last player whose General survives.',
  'rules.cardValuesTitle': 'Card Values',
  'rules.cardValues': 'Six=1, Seven=2, Eight=3, Nine=4, Ten=5, Unter=6, Ober=7, King=8, Ace=9',
  'rules.turnStart': 'At the beginning of each round, the player draws two hand cards from their deck. All hand cards must be played before the player may end their turn.',
  'rules.actionsTitle': 'Available Actions',
  'rules.action1': 'Attack an enemy card: Any hand card may be placed on any defender of any opponent to attack it. Multiple hand cards may attack the same defender. The attacking cards must be placed so that all values are visible. If the combined value of all attacking cards is equal to or less than the defender, the attacking cards remain. If the attacker value is higher, the defender is "captured" and it (along with all attacking cards) goes to the bottom of the currently attacking player\'s deck.',
  'rules.action2': 'Place a card as a defender: If the active player has fewer than two defenders, they may replace the missing defenders with their hand cards. A maximum of two defenders may be in front of the General at any time.',
  'rules.action3': 'Set aside a hand card face-down (stash) to use in a later round. Only ONE card may be stashed at a time. To use the stashed card, it must be picked up at the START of the round. Then one fewer card is drawn from the deck.',
  'rules.action4': 'If the drawn card is an Ace, you may optionally replace your own defender or General with the Ace. The replaced card and its attackers go to the bottom of the Ace owner\'s deck.',
  'rules.generalAttack': 'If an opponent has no defenders left (their defense was "broken through"), the active player attacks the opponent\'s General with their remaining hand cards. If the active player uses their last hand card to capture the last defender, the top card from the attacking player\'s deck is drawn to attack the exposed General. If a player is broken through without losing their General, they immediately get the next turn and may draw one extra card at the start.',
  'rules.losing': 'A player loses if their General is captured or they "starve": their deck has fewer cards at the start of their turn than they need to draw (stashed cards count). When a player loses, their General, defenders, all attacking cards, and any stashed card go under their deck, which is then shuffled and distributed to the remaining players. The game continues until only one player remains. The last surviving player wins.',
  'rules.tipTitle': 'Tip',
  'rules.tip': 'It\'s wise to "tend" your deck by preferring to capture strong cards and leaving weak hand cards to other players when possible. Aces are by far the most valuable cards, so try to keep them from reaching other players.',

  // Attributions
  'attributions.title': 'Attributions',
  'attributions.close': 'Close',
  'attributions.buttonTitle': 'Show credits and attributions',
  'attributions.gameDesignTitle': 'Game Design',
  'attributions.gameDesignBy': 'Original rules by Josef Emanuel Schmidt',
  'attributions.developmentTitle': 'Development',
  'attributions.developedBy': 'Digital implementation by Jakob Schmidt',
  'attributions.builtWithTitle': 'Built With',
  'attributions.builtWith': 'boardgame.io - Multiplayer game framework & cards.js - Card rendering library',
  'attributions.showSourceCode': 'Show Source Code',

  // Changelog
  'changelog.title': 'Changelog',
  'changelog.close': 'Close',
  'changelog.buttonTitle': 'Show version history',

  // Mode switcher
  'mode.switchToDev': 'Switch to Dev Mode',
  'mode.switchToOnline': 'Switch to Online Mode',
  'changelog.v0_15': 'Adjustments for Docker deployment in production environment',
  'changelog.v0_14': 'Added version button with changelog modal\nMoved version display to bottom-left button row',
  'changelog.v0_13': 'Added rules button with translated game rules',
  'changelog.v0_12': 'Added multi-language support (English and German)',
  'changelog.v0_11': 'Renamed "King" to "General" throughout the game\nExtended attack animations to General attacks\nAdded smooth overlay fade animations\nImproved visual highlights when cards are revealed',
  'changelog.v0_10': 'Added hand card parking area for better card management\nImplemented attack animations when capturing cards\nFixed consistent table positions for all players',
  'changelog.v0_9': 'Added custom player rotation for multi-player table layout',
  'changelog.v0_8': 'Implemented online multiplayer with lobby system\nAdded rematch functionality after game ends\nAdded end game card redistribution\nCore game logic with card highlighting and selection',
};
